import React from "react";
import LandingLayout from "./LandingLayout";
import { MdCheckCircle, MdNaturePeople, MdHealthAndSafety, MdVerified, MdGavel, MdGroups } from "react-icons/md";
import imgEnvironment from "../../img/img_ssma/environment.png";
import imgSafety from "../../img/img_ssma/safety.png";

const LandingSSMA = () => {
    const commitments = [
        {
            icon: MdVerified,
            text: "Mantener objetivos de Calidad, Gestión ambiental, Seguridad y Salud ocupacional afines con nuestra Política integral."
        },
        {
            icon: MdGroups,
            text: "Satisfacer los requerimientos de los Clientes, dando una respuesta oportuna mediante soluciones de confianza y cooperación."
        },
        {
            icon: MdNaturePeople,
            text: "Promover un ambiente limpio y ecológico, mejorando constantemente nuestro entorno."
        },
        {
            icon: MdGavel,
            text: "Cumplir estrictamente con las disposiciones legales en materia de seguridad y salud en el trabajo."
        },
        {
            icon: MdHealthAndSafety,
            text: "Originar participación y capacitación para fortalecer la calidad del servicio y sensibilizar sobre seguridad."
        },
        {
            icon: MdCheckCircle,
            text: "Fomentar en subcontratistas una actitud de seguridad en el desarrollo de sus trabajos."
        },
        {
            icon: MdHealthAndSafety,
            text: "Monitorear permanentemente la salud de los trabajadores para prevenir lesiones y enfermedades."
        },
        {
            icon: MdVerified,
            text: "Supervisar el cumplimiento de procedimientos, normas y obligaciones legales en los sitios de trabajo."
        }
    ];

    return (
        <LandingLayout>
            <div className="bg-white py-16 lg:py-24">
                {/* Hero / Intro Section */}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
                    <div className="text-center mb-16">
                        <h2 className="text-emerald-700 font-bold tracking-widest uppercase mb-3">Política Integrada</h2>
                        <h1 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                            Calidad, Medio Ambiente, <br className="hidden md:block" />
                            <span className="text-emerald-600">Seguridad y Salud Ocupacional</span>
                        </h1>
                        <div className="w-24 h-1 bg-emerald-500 mx-auto rounded-full"></div>
                    </div>

                    <div className="flex flex-col lg:flex-row gap-12 items-center">
                        <div className="lg:w-1/2 space-y-6 text-lg text-gray-600 leading-relaxed text-justify">
                            <p>
                                Somos una empresa dedicada a asesorar y mantener plantas de almacenamiento y distribución de combustible a lo largo del país. Entregando siempre un servicio de reconocida calidad, comprometidos con el <span className="font-semibold text-emerald-800">desarrollo sustentable</span> y velando por la seguridad y salud de nuestros trabajadores.
                            </p>
                            <p>
                                Nuestros más de siete años de servicios validan nuestra competencia, permitiéndonos brindar servicios caracterizados por el compromiso, calidad y entrega oportuna.
                            </p>
                            <p className="font-medium text-gray-800 border-l-4 border-emerald-500 pl-4 italic bg-emerald-50/50 p-4 rounded-r-lg">
                                Visionamos ser la empresa líder en el mercado nacional, comprometidos con la mejora continua.
                            </p>
                        </div>
                        <div className="lg:w-1/2 relative group">
                            <div className="absolute -inset-2 bg-emerald-100 rounded-[2rem] transform rotate-2 group-hover:rotate-1 transition-transform duration-500"></div>
                            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl h-[400px]">
                                <img
                                    src={imgEnvironment}
                                    alt="Medio Ambiente Industrial"
                                    className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/40 to-transparent"></div>
                                <div className="absolute bottom-6 left-6 right-6 text-white">
                                    <div className="flex items-center gap-2 mb-2">
                                        <MdNaturePeople className="w-6 h-6 text-emerald-300" />
                                        <span className="text-emerald-100 font-semibold uppercase tracking-wider text-sm">Sustentabilidad</span>
                                    </div>
                                    <p className="font-bold text-xl">Compromiso con el Medio Ambiente</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Commitments Section */}
                <div className="bg-emerald-900 text-white py-20 relative overflow-hidden">
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute right-0 top-0 w-96 h-96 bg-emerald-400 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
                        <div className="absolute left-0 bottom-0 w-96 h-96 bg-emerald-600 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
                    </div>

                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="flex flex-col lg:flex-row gap-16 items-start">
                            {/* Left Side: Image & Title */}
                            <div className="lg:w-1/3 sticky top-8">
                                <h3 className="text-emerald-400 font-bold uppercase tracking-widest mb-4">Nuestros Compromisos</h3>
                                <h2 className="text-3xl font-bold mb-8 leading-snug">
                                    ASESORÍAS TÉCNICAS Y MANTENCIÓN LTDA. se compromete a:
                                </h2>
                                <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-emerald-800">
                                    <img
                                        src={imgSafety}
                                        alt="Seguridad y Salud"
                                        className="w-full h-64 object-cover"
                                    />
                                    <div className="bg-emerald-800 p-6">
                                        <p className="text-emerald-100 text-sm italic">
                                            "Asegurando que cada miembro de la Organización entienda, participe y tome como propios sus principios."
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Right Side: Grid of Commitments */}
                            <div className="lg:w-2/3">
                                <div className="grid sm:grid-cols-2 gap-6">
                                    {commitments.map((item, idx) => (
                                        <div key={idx} className="bg-emerald-800/50 backdrop-blur-sm border border-emerald-700/50 p-6 rounded-xl hover:bg-emerald-800 transition-colors duration-300 group">
                                            <div className="w-12 h-12 bg-emerald-700 rounded-lg flex items-center justify-center text-emerald-300 mb-4 group-hover:bg-emerald-600 group-hover:text-white transition-all">
                                                <item.icon size={28} />
                                            </div>
                                            <p className="text-emerald-100 leading-relaxed text-sm">
                                                {item.text}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Quote */}
                <div className="max-w-4xl mx-auto px-4 py-16 text-center">
                    <p className="text-gray-500 italic">
                        ASESORÍAS TÉCNICAS Y MANTENCIÓN LTDA. revisará periódicamente la adecuación de esta Política y se compromete a implementar y mantenerla.
                    </p>
                </div>
            </div>
        </LandingLayout>
    );
};

export default LandingSSMA;
